import React, { useEffect, useState } from 'react';
import { api, API_ORIGIN } from '../../api.js';
import FileThumbPicker from './FileThumbPicker.jsx';

const CATEGORIES = [
  { key: 'inspections', label: 'Inspections' },
  { key: 'repairs', label: 'Repairs' },
  { key: 'road_side_fix', label: 'Road Side Fix' },
  { key: 'insurance_payments', label: 'Insurance Payments' },
  { key: 'tickets_accidents', label: 'Tickets & Accidents' }
];

// No detailed field spec was given for these 5 categories (same as
// trucks), so this is the same simple Date + Description + file starter.
export default function TrailerDocumentsTab({ trailerId }) {
  const [category, setCategory] = useState('inspections');
  const [entries, setEntries] = useState({});
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');
  const [uploadedFile, setUploadedFile] = useState(null);

  const load = (cat) => {
    api(`/dispatch/trailers/${trailerId}/documents?category=${cat}`)
      .then(rows => setEntries(e => ({ ...e, [cat]: rows })))
      .catch(() => setEntries(e => ({ ...e, [cat]: [] })));
  };
  useEffect(() => { load(category); }, [category]);

  const add = async () => {
    if (!description.trim()) return;
    await api(`/dispatch/trailers/${trailerId}/documents`, {
      method: 'POST',
      body: {
        category, entryDate: date, description,
        fileName: uploadedFile?.fileName || '', fileUrl: uploadedFile?.url || ''
      }
    });
    setDate(''); setDescription(''); setUploadedFile(null);
    load(category);
  };

  const deleteEntry = async (id) => {
    await api(`/dispatch/trailers/${trailerId}/documents/${id}`, { method: 'DELETE' });
    load(category);
  };

  const rows = entries[category] || [];

  return (
    <div>
      <div className="driver-subtabs">
        {CATEGORIES.map(c => (
          <button key={c.key} type="button" className={'driver-subtab' + (category === c.key ? ' active' : '')}
            onClick={() => setCategory(c.key)}>{c.label}</button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: 10, marginBottom: 14 }}>
        <input type="date" value={date} onChange={e => setDate(e.target.value)} />
        <input placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} />
      </div>
      <div style={{ marginBottom: 14 }}>
        <FileThumbPicker value={uploadedFile} onChange={setUploadedFile} />
      </div>
      <button type="button" className="primary-btn" onClick={add} style={{ marginBottom: 18 }}>+ Add</button>

      {rows.length === 0 ? <div className="empty">No entries yet.</div> : (
        <table>
          <thead><tr><th>Date</th><th>Description</th><th>File</th><th></th></tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td>{r.entry_date || '—'}</td>
                <td>{r.description}</td>
                <td>{r.file_url ? <a href={`${API_ORIGIN}${r.file_url}`} target="_blank" rel="noreferrer">{r.file_name || 'View'}</a> : '—'}</td>
                <td><button type="button" onClick={() => deleteEntry(r.id)} style={{ color: 'var(--red)' }}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
